<div class="container">
    <div
        style="display: flex; 
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100vh;"            
    >

        <div class="row">
            <h4>Recuperar contraseña</h4>
        </div>

        <div class="row">
            <lottie-player src="/assets/lottie/forgot_password.json" background="transparent" speed="1" loop autoplay
          style="width:350px;height:350px"></lottie-player>
        </div>

        <div class="row">

            <form  [formGroup]="formRecoverPassword"  >
                <div class="form-group">
                    <p
                        style="font-size: 1.4em;"
                    >Ingresa el correo asociado a tu cuenta para poder realizar la recuperación de contraseña:</p>
                    <input type="text"
                        formControlName="email"
                    class="form-control" placeholder="example@gmail.com" />
                </div>
                <div class="form-group mt-4">
                    <button 
                        class="btn btn-primary"
                            (click)="sendRecoverPasswordRequest()"
                            [disabled]="loadingResetPassword"
                        >Enviar correo de recuperación 
                        <i 
                            *ngIf="!loadingResetPassword"
                        class="fa fa-unlock"></i>
                        <i 
                            *ngIf="loadingResetPassword"
                        class="fa fa-spinner fa-pulse"></i>
                    </button>
                </div>
            </form>                    
        </div>
    </div>
</div>